import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-23e6becb"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tenant-home"
};
const _hoisted_2 = {
  class: "summary-row"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "summary-text"
};
const _hoisted_5 = {
  class: "summary-label"
};
const _hoisted_6 = {
  key: 0,
  class: "summary-note"
};
const _hoisted_7 = {
  class: "charts-row"
};
const _hoisted_8 = {
  class: "panel trend-panel"
};
const _hoisted_9 = {
  class: "panel-title"
};
const _hoisted_10 = {
  class: "panel category-panel"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "告警分类", -1));
const _hoisted_12 = {
  class: "category-charts"
};
const _hoisted_13 = {
  class: "category-chart-wrap"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-chart-title"
}, "告警类型", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-divider"
}, null, -1));
const _hoisted_16 = {
  class: "category-chart-wrap"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "category-chart-title"
}, "告警级别", -1));
const _hoisted_18 = {
  class: "bottom-row"
};
const _hoisted_19 = {
  class: "panel latest-panel"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "最新告警", -1));
const _hoisted_21 = {
  class: "panel task-panel"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "panel-title"
}, "待处理任务", -1));
const _hoisted_23 = {
  class: "task-summary"
};
const _hoisted_24 = {
  class: "task-section task-pending"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  class: "task-info"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "task-label"
}, "待审批", -1));
const _hoisted_28 = {
  class: "text-blue"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-divider"
}, null, -1));
const _hoisted_30 = {
  class: "task-section"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "task-label"
}, "开阀申请", -1));
const _hoisted_32 = {
  class: "text-green"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "task-divider"
}, null, -1));
const _hoisted_34 = {
  class: "task-section"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "task-label"
}, "关阀申请", -1));
const _hoisted_36 = {
  class: "text-red"
};
import { computed, nextTick, onBeforeUnmount, onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import * as echarts from 'echarts';
import iconDai from '@/assets/img/icon-dai.png';
import iconZz from '@/assets/img/icon-zz.png';
import iconZx from '@/assets/img/icon-zx.png';
import iconLx from '@/assets/img/icon-lx.png';
import iconGj from '@/assets/img/icon-gj.png';
import iconZc from '@/assets/img/icon-zc.png';
import { getTenantAlarmCategories, getTenantAlarmTrend, getTenantLatestAlarms, getTenantPendingTasks, getTenantSummary } from '@/api/homePage';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const loading = ref(false);
    const period = ref('week');
    const summary = reactive({});
    const alarmTrend = ref([]);
    const alarmCategoryOverview = reactive({
      alarmTypes: [],
      alarmLevels: []
    });
    const latestAlarms = ref([]);
    const pendingTasks = ref([]);
    const trendChart = ref(null);
    const alarmTypeChart = ref(null);
    const alarmLevelChart = ref(null);
    let trendInstance;
    let alarmTypeInstance;
    let alarmLevelInstance;
    let isPageMounted = false;
    let trendRequestId = 0;
    const summaryCards = [{
      key: 'totalCount',
      label: '执行器总数',
      icon: iconZz,
      color: 'blue'
    }, {
      key: 'onlineCount',
      label: '在线数量',
      icon: iconZx,
      color: 'green'
    }, {
      key: 'offlineCount',
      label: '离线数量',
      icon: iconLx,
      color: 'orange'
    }, {
      key: 'alarmCount',
      label: '告警设备',
      icon: iconGj,
      color: 'red'
    }, {
      key: 'normalCount',
      label: '正常数量',
      icon: iconZc,
      color: 'green',
      note: '在线且无告警'
    }];
    const number = value => Number(value || 0).toLocaleString();
    const openCount = computed(() => pendingTasks.value.filter(item => item.valuePos === 1).length);
    const closeCount = computed(() => pendingTasks.value.filter(item => item.valuePos !== 1).length);
    const categoryName = name => ({
      control: '控制类告警',
      power: '电源类告警',
      detector: '探测类告警',
      comm: '通信类告警',
      valve: '阀门类告警',
      communication: '通信类告警',
      other: '其他告警'
    })[name] || name || '其他告警';
    const categoryColors = ['#f43f3f', '#ff9800', '#287fea', '#16ae6d', '#8b5cf6'];
    const setCategoryPie = (instance, rows, formatName, totalLabel) => {
      const data = (rows || []).map((item, index) => ({
        value: item.value || 0,
        name: formatName(item.name),
        itemStyle: {
          color: categoryColors[index % categoryColors.length]
        }
      }));
      const total = data.reduce((sum, item) => sum + Number(item.value || 0), 0);
      instance.setOption({
        tooltip: {
          trigger: 'item',
          backgroundColor: 'rgba(255,255,255,.96)',
          borderColor: '#e8edf3',
          borderWidth: 1,
          textStyle: {
            color: '#334155',
            fontSize: 12
          },
          formatter: p => `<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${p.color};margin-right:6px;"></span>${p.name}<br/><span style="font-weight:700;font-size:15px;">${p.value}</span> <span style="color:#94a3b8;">(${p.percent}%)</span>`
        },
        legend: {
          type: 'scroll',
          bottom: 0,
          left: 'center',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 10,
          icon: 'circle',
          textStyle: {
            fontSize: 11,
            color: '#64748b',
            padding: [0, 0, 0, 2]
          }
        },
        graphic: [{
          type: 'text',
          left: 'center',
          top: '34%',
          style: {
            text: `${total}`,
            textAlign: 'center',
            fontSize: 22,
            fontWeight: 800,
            lineHeight: 26,
            fill: '#1e293b'
          }
        }, {
          type: 'text',
          left: 'center',
          top: '48%',
          style: {
            text: totalLabel,
            textAlign: 'center',
            fontSize: 11,
            fontWeight: 400,
            fill: '#94a3b8'
          }
        }],
        series: [{
          type: 'pie',
          radius: ['36%', '72%'],
          center: ['50%', '42%'],
          padAngle: 2,
          itemStyle: {
            borderRadius: 4,
            borderColor: '#fff',
            borderWidth: 2
          },
          emphasis: {
            scaleSize: 6,
            itemStyle: {
              shadowBlur: 12,
              shadowColor: 'rgba(0,0,0,.15)'
            }
          },
          label: {
            show: false
          },
          data
        }]
      });
    };
    const renderTrend = () => nextTick(() => {
      if (!isPageMounted || !trendChart.value) return;
      trendInstance ||= echarts.init(trendChart.value);
      trendInstance.setOption({
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255,255,255,.96)',
          borderColor: '#e8edf3',
          borderWidth: 1,
          textStyle: {
            color: '#334155',
            fontSize: 12
          }
        },
        legend: {
          top: 2,
          textStyle: {
            color: '#64748b',
            fontSize: 12
          }
        },
        grid: {
          left: 42,
          right: 34,
          top: 42,
          bottom: 28
        },
        xAxis: {
          type: 'category',
          data: alarmTrend.value.map(item => item.label)
        },
        yAxis: [{
          type: 'value'
        }, {
          type: 'value',
          splitLine: {
            show: false
          }
        }],
        series: [{
          name: '告警总数',
          type: 'bar',
          barWidth: 25,
          data: alarmTrend.value.map(item => item.alarmCount),
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: '#4facfe'
            }, {
              offset: 1,
              color: '#2f89ed'
            }]),
            borderRadius: [4, 4, 0, 0]
          },
          emphasis: {
            itemStyle: {
              color: '#1677ff'
            }
          }
        }, {
          name: '严重告警',
          type: 'line',
          yAxisIndex: 1,
          smooth: true,
          symbol: 'circle',
          symbolSize: 6,
          data: alarmTrend.value.map(item => item.severeCount),
          lineStyle: {
            width: 2.5
          },
          itemStyle: {
            color: '#ff8a00'
          },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(255,138,0,.18)'
            }, {
              offset: 1,
              color: 'rgba(255,138,0,0)'
            }])
          }
        }]
      });
    });
    const renderCategories = () => nextTick(() => {
      if (!isPageMounted || !alarmTypeChart.value || !alarmLevelChart.value) return;
      alarmTypeInstance ||= echarts.init(alarmTypeChart.value);
      alarmLevelInstance ||= echarts.init(alarmLevelChart.value);
      setCategoryPie(alarmTypeInstance, alarmCategoryOverview.alarmTypes, categoryName, '类型告警');
      setCategoryPie(alarmLevelInstance, alarmCategoryOverview.alarmLevels, name => name || '未配置级别', '级别告警');
    });
    const loadTrend = async () => {
      const requestedPeriod = period.value;
      const requestId = ++trendRequestId;
      try {
        const trendRes = await getTenantAlarmTrend(requestedPeriod);
        if (!isPageMounted || requestId !== trendRequestId || period.value !== requestedPeriod) return;
        alarmTrend.value = trendRes.data || [];
        renderTrend();
      } catch (error) {
        if (isPageMounted && requestId === trendRequestId && period.value === requestedPeriod) ElMessage.error('告警趋势加载失败');
      }
    };
    const loadData = async () => {
      loading.value = true;
      const requestedPeriod = period.value;
      const requestId = ++trendRequestId;
      try {
        const [summaryRes, trendRes, categoryRes, alarmRes, taskRes] = await Promise.all([getTenantSummary(), getTenantAlarmTrend(requestedPeriod), getTenantAlarmCategories(), getTenantLatestAlarms(), getTenantPendingTasks()]);
        if (!isPageMounted) return;
        Object.assign(summary, summaryRes.data || {});
        if (requestId === trendRequestId && period.value === requestedPeriod) {
          alarmTrend.value = trendRes.data || [];
          renderTrend();
        }
        alarmCategoryOverview.alarmTypes = categoryRes.data?.alarmTypes || [];
        alarmCategoryOverview.alarmLevels = categoryRes.data?.alarmLevels || [];
        latestAlarms.value = alarmRes.data || [];
        pendingTasks.value = taskRes.data || [];
        renderCategories();
      } catch (error) {
        if (isPageMounted) ElMessage.error('首页数据加载失败');
      } finally {
        if (isPageMounted) loading.value = false;
      }
    };
    const goApproval = row => router.push({
      path: '/workManage',
      query: {
        id: row.id
      }
    });
    const resize = () => {
      trendInstance?.resize();
      alarmTypeInstance?.resize();
      alarmLevelInstance?.resize();
    };
    onMounted(() => {
      isPageMounted = true;
      loadData();
      window.addEventListener('resize', resize);
    });
    onBeforeUnmount(() => {
      isPageMounted = false;
      window.removeEventListener('resize', resize);
      trendInstance?.dispose();
      alarmTypeInstance?.dispose();
      alarmLevelInstance?.dispose();
    });
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_button = _resolveComponent("el-button");
      const _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("section", _hoisted_2, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(summaryCards, item => {
        return _createElementVNode("div", {
          key: item.key,
          class: _normalizeClass(['summary-card', `card-${item.color}`])
        }, [_createElementVNode("img", {
          src: item.icon,
          class: "summary-icon",
          alt: item.label
        }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1), _createElementVNode("strong", {
          class: _normalizeClass(['summary-value', `val-${item.color}`])
        }, _toDisplayString(number(summary[item.key])), 3), item.note ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(item.note), 1)) : _createCommentVNode("", true)])], 2);
      }), 64))]), _createElementVNode("section", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createTextVNode("执行器告警趋势 "), _createVNode(_component_el_radio_group, {
        modelValue: period.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => period.value = $event),
        size: "small",
        onChange: loadTrend
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          value: "week"
        }, {
          default: _withCtx(() => [_createTextVNode("近7天")]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          value: "month"
        }, {
          default: _withCtx(() => [_createTextVNode("近1年")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", {
        ref_key: "trendChart",
        ref: trendChart,
        class: "chart"
      }, null, 512)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createElementVNode("div", {
        ref_key: "alarmTypeChart",
        ref: alarmTypeChart,
        class: "category-chart"
      }, null, 512)]), _hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", {
        ref_key: "alarmLevelChart",
        ref: alarmLevelChart,
        class: "category-chart"
      }, null, 512)])])])]), _createElementVNode("section", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_hoisted_20, _createVNode(_component_el_table, {
        data: latestAlarms.value,
        height: "calc(100% - 44px)",
        size: "small",
        stripe: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "alarmTime",
          label: "告警时间",
          width: "150"
        }), _createVNode(_component_el_table_column, {
          prop: "actuatorNum",
          label: "执行器编号",
          "min-width": "130",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "deviceName",
          label: "设备名称",
          "min-width": "130",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "alarmType",
          label: "告警类型",
          "min-width": "130",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          label: "级别",
          width: "72",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: scope.row.severity <= 2 ? 'danger' : 'warning',
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.severity <= 2 ? '严重' : '一般'), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "状态",
          width: "82",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: scope.row.handled ? 'primary' : 'danger',
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.handled ? '已确认' : '未处理'), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
        src: _unref(iconDai),
        class: "task-icon",
        alt: "待审批"
      }, null, 8, _hoisted_25), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("strong", _hoisted_28, _toDisplayString(pendingTasks.value.length), 1)])]), _hoisted_29, _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("strong", _hoisted_32, _toDisplayString(_unref(openCount)), 1)]), _hoisted_33, _createElementVNode("div", _hoisted_34, [_hoisted_35, _createElementVNode("strong", _hoisted_36, _toDisplayString(_unref(closeCount)), 1)])]), _createVNode(_component_el_table, {
        data: pendingTasks.value,
        height: "calc(100% - 132px)",
        size: "small",
        stripe: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "applyUser",
          label: "申请人",
          width: "80"
        }, {
          default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.applyUser || '--'), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "actNum",
          label: "执行器编号",
          "min-width": "125",
          "show-overflow-tooltip": ""
        }), _createVNode(_component_el_table_column, {
          prop: "applyTime",
          label: "申请时间",
          width: "145"
        }), _createVNode(_component_el_table_column, {
          label: "类型",
          width: "65",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_tag, {
            type: scope.row.valuePos === 1 ? 'primary' : 'danger',
            size: "small"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row.valuePos === 1 ? '开阀' : '关阀'), 1)]),
            _: 2
          }, 1032, ["type"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "75",
          align: "center"
        }, {
          default: _withCtx(scope => [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            onClick: $event => goApproval(scope.row)
          }, {
            default: _withCtx(() => [_createTextVNode("去审批")]),
            _: 2
          }, 1032, ["onClick"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"])])])])), [[_directive_loading, loading.value]]);
    };
  }
};